import i18n from 'app/i18l'
import { WelcomeScreenProps } from 'onboarding/stack/types'
import { WelcomeView } from 'onboarding/views/welcome'
import React, { useCallback } from 'react'
import { View } from 'react-native'

export function WelcomeScreen({ navigation }: WelcomeScreenProps) {
  const onSignIn = useCallback(
    async (locale: string) => {
      i18n.locale = locale
      navigation.navigate('verify')
    },
    [navigation]
  )

  return (
    <View style={{ flex: 1 }}>
      <WelcomeView onSignIn={onSignIn} />
    </View>
  )
}
